import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom as _fvf } from 'rxjs';
import { IService } from '../../../../core/interfaces/i.service.interface';
import { IResponse } from '../../../../core/interfaces/response.interface';
import { ILoginResponse, ISignUpResponse } from '../interface';
@Injectable({ providedIn: 'root' })
export class AuthService implements IService {
  _baseUrl = 'auth/';
  constructor(private http: HttpClient) {}

  signUp(body: any) {
    return _fvf(
      this.http.post<IResponse<ISignUpResponse>>(
        `${this._baseUrl}sign-up`,
        body,
      ),
    );
  }

  login(body: any) {
    return _fvf(
      this.http.post<IResponse<ILoginResponse>>(`${this._baseUrl}log-in`, body),
    );
  }

  verifyEmailResendCode(body: any) {
    return _fvf(
      this.http.post<IResponse<undefined>>(
        `${this._baseUrl}verify-email-resend-code`,
        body,
      ),
    );
  }

  verifyEmail(body: any) {
    return _fvf(
      this.http.post<IResponse<undefined>>(
        `${this._baseUrl}verify-email`,
        body,
      ),
    );
  }

  resetPasswordResendCode(body: any) {
    return _fvf(
      this.http.post<IResponse<undefined>>(
        `${this._baseUrl}reset-password-resend-code`,
        body,
      ),
    );
  }
  verifyResetPasswordCode(body: any) {
    return _fvf(
      this.http.post<IResponse<undefined>>(
        `${this._baseUrl}verify-reset-password-code`,
        body,
      ),
    );
  }

  resetPassword(body: any) {
    return _fvf(
      this.http.post<IResponse<undefined>>(
        `${this._baseUrl}reset-password`,
        body,
      ),
    );
  }

  logInByGoogle(accessToken: any) {
    return _fvf(
      this.http.post<IResponse<ILoginResponse>>(
        `${this._baseUrl}login-by-google`,
        { accessToken },
      ),
    );
  }
}
